/* 
设备盘点接口
*/
import request from '@/util/request';
import qs from 'qs';

export const getInventoryList = (params, options) =>
request.get('/api/v4ward/device/check/page', Object.assign({}, options, { params }));
//获取盘点单号
export const getInventoryCode = () =>
request.get('/api/v4ward/device/check/getDeviceCheckNo');

//选择设备
export const getChoiceDeviceList = (params, options) =>
request.get('/api/v4ward/device/check/batchdevicecheck', Object.assign({}, options, { params }));

//新增or编辑提交
export const submitInventory = (params, options) =>
request.post('/api/v4ward/device/check/save', params, options);
//盘点状态切换
export const updatetInventoryStatus = (params, options) =>
request.post('/api/v4ward/device/check/updateCheckStatus', params, options);

//编辑盘点单回显数据
export const getInventoryDetail = (id) =>
request.get('/api/v4ward/device/check/detailDevice?id='+id);

//编辑盘点单提交
export const submitEditInventory = (params, options) =>
request.post('/api/v4ward/device/check/submit', params, options);

//删除盘点
export const removeInventory = (id) =>
request.post('/api/v4ward/device/check/remove?id='+id);


//获取设备带分页查询
export const getDeviceList = (params, options) =>
request.get('/api/v4ward/repair/task/device/selectDevice', Object.assign({}, options, { params }));

//获取关联了标准的设备
export const getHasStandardDeviceList = (params, options) =>
request.get('/api/deviceinspecttasklist/taskDevice', Object.assign({}, options, { params }));